import moment from 'moment'
import { getActivityById, getAllActivity, getActivity, putActivity, postActivity, deleteActivity } from '../../../../api/eastCoastDataApi/Activity/Activity'
import Utils from '../../../../utils/utils'
import CONST from '../../../../utils/const'
import config from '../../../../config'

const state = {
  allActivitys: [],
  activities: []
}

const getters = {
  getActivities: state => {
    return state.activities
  },
  getActivityById: state => (id) => {
    return state.activities.filter(act => act.id === id)
  }
}

const actions = {
  async getActivityById({ commit }, id) {
    const result =  await getActivityById(id)
    return result
  },

  async getAllActivity({ commit }) {
    const result = await getAllActivity()
    if (result.success) {
      commit('allActivitys', result.data)
    }
    
  },

  async getActivities({ commit }, condition) {
    const result = await getActivity(condition)
    if (result.success) {
      commit('activities', result.data)
      return  result.data
    } else {
      return []
    }
  },

  async postActivity({ commit }, activity) {
    const result = await postActivity(activity)
    if (result.success) {
      commit('updateActivity', { data: result.data, mode: 'post' })
    }

    return result
  },

  async putActivity({ commit }, activity) {
    const result = await putActivity(activity)
    if (result.success) {
      commit('updateActivity', { data: result.data, mode: 'put' })
    }

    return result
  },

  async deleteActivity({ commit }, activity) {
    const result = await deleteActivity(activity)
    if (result.success) {
      result.data = activity.id //delete 204, result.data = ""
      commit('updateActivity', { data: result.data, mode: 'delete' })
    }

    return result
  }
}

const mutations = {
  allActivitys(state, data) {
    if (Utils.isEmptyObject(data)) {
      return
    }

    helpers.sortByStartTime(data)
    data.forEach(activity => helpers.setActivtyStatus(activity))
    const activityList = helpers.sortByStatus(data)

    state.allActivitys = activityList
    state.activities = activityList
  },

  activities(state, data) {
    if (Utils.isEmptyObject(data)) {
      state.activities = [] // e.g 查無關鍵字，會回空陣列
      return
    }

    helpers.sortByStartTime(data)
    data.forEach(activity => helpers.setActivtyStatus(activity))
    const activityList = helpers.sortByStatus(data)
    
    state.activities = activityList
  },

  updateActivity(state, { data, mode }) {
    switch (mode) {
      case 'post':
        state.activities.push(data)
        break
      
      case 'put':
        const index = state.activities.findIndex(d => d.id === data.id)
        if(index === -1)
          break;

        state.activities[index] = data
        state.activities = JSON.parse(JSON.stringify(state.activities))
        break
  
      case 'delete' :
        state.activities = state.activities.filter(d => d.id !== data)
        break    
    }
  },
}

const helpers = {
  sortByStartTime (data){
    data.sort((a, b) => {
      return a.startDate.localeCompare(b.startDate)
    })
  },
  
  setActivtyStatus(activity) {
    if(moment(activity.startDate).isAfter(moment().endOf('day'))) {
      activity.status = CONST.ACTIVITY_STATUS.WILL // 尚未開始
    } else if(moment(activity.endDate).isBefore(moment().startOf('day'))) {
      activity.status = CONST.ACTIVITY_STATUS.END //已結束
    } else {
      activity.status = CONST.ACTIVITY_STATUS.DURING
    }
  },

  sortByStatus(data) {
    const duringActivity = data.filter(activity => activity.status === CONST.ACTIVITY_STATUS.DURING)
    const willActivity = data.filter(activity => activity.status === CONST.ACTIVITY_STATUS.WILL)
    const endActivity = data.filter(activity => activity.status === CONST.ACTIVITY_STATUS.END)

    return [].concat(duringActivity).concat(willActivity).concat(endActivity)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}